<template>
  <CustomPage :noTitle="true">
    <div slot="content" class="page-content">
      <div class="discovery-container">
        <div class="header">
          <Header ref="Header" @search="search" />
          <Navbar ref="Navbar" @menuChange="menuChange" @search="search" />
        </div>
        <div class="list-wrapper">
          <VirtualList
            :list="list"
            :dataComponent="dataComponent"
            @getData="getData"
            :finished="finished"
          />
        </div>
        <Tabbar @addDiscovery="addDiscoveryOpen" />
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>
<script>
import Bus from '@/utils/bus'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import Tabbar from '@/components/Tabbar'
import Header from './components/Header'
import Navbar from './components/Navbar'
import VirtualList from '@/components/VirtualList'
import dataComponent from './components/Item'
import {
  getMaterialList,
  getOfficialList,
  getGrowingList,
} from '@/api/discovery'
import { Toast } from 'vant'

export default {
  name: 'Discovery',
  components: {
    CustomPage,
    CustomView,
    Tabbar,
    Header,
    Navbar,
    VirtualList,
  },
  data() {
    return {
      dataComponent,
      list: [],
      finished: false,
      pagination: {
        page: 0,
        size: 10,
      },
    }
  },
  created() {
    Bus.$on('discoveryRefreshData', this.discoveryRefreshData)
  },
  methods: {
    getMaterialList() {
      const params = this.converParams()
      params.goodsName = this.$refs.Header.value
      getMaterialList(params)
        .then(this.converData)
        .catch(() => {
          Toast.fail('获取数据失败')
          this.finished = true
        })
    },
    getOfficialList() {
      const params = this.converParams()
      params.content = this.$refs.Header.value
      getOfficialList(params)
        .then(this.converData)
        .catch(() => {
          Toast.fail('获取数据失败')
          this.finished = true
        })
    },
    getGrowingList() {
      const params = this.converParams()
      params.content = this.$refs.Header.value
      getGrowingList(params)
        .then(this.converData)
        .catch(() => {
          Toast.fail('获取数据失败')
          this.finished = true
        })
    },
    converParams() {
      const sort_active = this.$refs.Navbar.sort_active
      return {
        page: this.pagination.page,
        size: this.pagination.size,
        sortColumn: sort_active === '时间' ? 'createTime' : 'forwardNum',
        sortRole: 'DESC'
      }
    },
    converData(res) {
      const data = res.data.content.map((item) => {
        const obj = { desc_fold: null, desc: item.content, fold: false }
        if (item.content.length > 100) {
          obj.desc_fold = item.content.slice(0, 100)
          obj.fold = false
        }
        return { ...item, ...obj }
      })
      this.list.push(...data)
      if (data.length < this.pagination.size) {
        this.finished = true
      } else {
        this.pagination.page++
      }
    },
    getData() {
      const menu_active = this.$refs.Navbar.menu_active
      menu_active === '店长素材' && this.getMaterialList()
      menu_active === '官方公告' && this.getOfficialList()
      menu_active === '新人成长' && this.getGrowingList()
    },
    search() {
      this.list = []
      this.pagination.page = 0
      this.finished = false
      this.getData()
    },
    menuChange() {
      this.$refs.Header.value = null
      this.search()
    },
    discoveryRefreshData() {
      const menu_active = this.$refs.Navbar.menu_active
      menu_active === '店长素材' && this.menuChange()
    },
    addDiscoveryOpen() {
      console.log(this.pagination)
      this.$router.push({ name: 'DiscoveryCreate' })
    },
  },
}
</script>
<style lang="less" scoped>
.page-content {
  height: 100%;
  padding-bottom: 100px;
}
.discovery-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    background: #ffffff;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
    z-index: 9;
  }
  .list-wrapper {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    background-color: #f8f8f8;
  }
}
</style>